import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  filterBy,
  CompositeFilterDescriptor,
} from "@progress/kendo-data-query";
import {
  Grid as KendoGrid,
  GridColumn as Column,
  GridCellProps,
  GridFilterChangeEvent,
  GridPageChangeEvent,
  GridCustomHeaderCellProps,
  GridCustomCellProps,
} from "@progress/kendo-react-grid";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { HeaderThElement } from "@progress/kendo-react-data-tools";
import { Typography } from "@progress/kendo-react-common";
import {
  Button,
  DropDownButton,
  DropDownButtonItem,
} from "@progress/kendo-react-buttons";
// import { FiEdit } from "react-icons/fi";
import { LoadingPanel } from "../../components/layout/Loading";
import IconButton from "../../components/common/IconButton";
import AppDialog, { DialogCloseButton } from "../../components/dialog/Dialog";
import { MdDelete } from "react-icons/md";
import { closeDialog, openDialog } from "../../components/dialog/dialogSlice";
import {
  deleteShippingMovements,
  getAllShippingMovements,
} from "./services/shippingMovementsList.services";
import {
  clearFilter,
  clearShippingMovementsGUID,
  setShippingMovementsGUID,
} from "./shippingMovementsListSlice";
import { checkAcessRights } from "../../_helper/helper";
import {
  DELETE_ACCESS,
  EDIT_ACCESS,
  INSERT_ACCESS,
} from "../../_contstants/common";
import { setCurrentPage, setPageLimit } from "../pagination/paginationSlice";
import {
  filterIcon,
  // pencilIcon,
  plusCircleIcon,
} from "@progress/kendo-svg-icons";
import { Tooltip } from "@progress/kendo-react-tooltip";
import SMFilter from "./SMFilter";
import { RootState } from "../../app/store";
import { Badge } from "@progress/kendo-react-indicators";
import { FiEdit } from "react-icons/fi";
import moment from "moment";
const ShippingMovementsList: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const isAddAccess = checkAcessRights(location.pathname, INSERT_ACCESS);

  // const handleCreate = () => {
  //   navigate("/shippingmovements/create");
  // };
  const isFilterSet = useAppSelector(
    (state: RootState) => state.shippingMovementslist.isFilterSet
  );

  const handleItemClick = (event: any) => {
    const clickedItem = event?.item?.text;
    if (clickedItem === "Shipping Movements") {
      navigate("/shippingmovements/create");
    } else if (clickedItem === "Container Import Discharge") {
      navigate("/containerimportdischarge/create");
    } else if (clickedItem === "Vessels Export Loading") {
      navigate("/vesselsexportloading/create");
    }
  };

  const handleOpenSMFilter = () => {
    dispatch(openDialog("SMFilter"));
  };


  return (
    <>
      <SMFilter />
      <DeleteShippingMovementsDialog />
      <GridLayout cols={[{ width: "100%" }]}>
        <GridLayoutItem
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "4px 20px 20px 0",
          }}
        >
          <Typography.h4 style={{ marginBottom: 0, marginLeft: "3px" }}>
            Shipping Movement List
          </Typography.h4>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginLeft: "auto",
              paddingRight: "20px",
              gap: "15px",
            }}
          >
            <Button
              onClick={handleOpenSMFilter}
              fillMode={"solid"}
              themeColor={"primary"}
              svgIcon={filterIcon}
              // style={{ marginRight: 9 }}
            >
              Filter
              {isFilterSet ? <Badge themeColor="error" /> : ""}
            </Button>
            {isAddAccess && (
              <Tooltip anchorElement="target" position="top" parentTitle={true}>
                <DropDownButton
                  className="sales-printing-opt-btn"
                  text="Add New"
                  title="Add New"
                  themeColor={"primary"}
                  onItemClick={handleItemClick}
                  popupSettings={{
                    anchorAlign: { horizontal: "right", vertical: "bottom" },
                    popupAlign: { horizontal: "center", vertical: "top" },
                    popupClass: "custom-popup-width",
                  }}
                >
                  <DropDownButtonItem
                    svgIcon={plusCircleIcon}
                    text="Shipping Movements"
                  />
                  <DropDownButtonItem
                    text="Container Import Discharge"
                    svgIcon={plusCircleIcon}
                  />
                  <DropDownButtonItem
                    svgIcon={plusCircleIcon}
                    text="Vessels Export Loading"
                  />
                </DropDownButton>
              </Tooltip>
            )}
          </div>
          {/* )} */}
        </GridLayoutItem>
        <GridLayoutItem>
          <ShippingMovementsGridComponent />
        </GridLayoutItem>
      </GridLayout>
    </>
  );
};

const ShippingMovementsGridComponent: React.FC = () => {
  const gridRef = useRef<any>(null);
  const isEditBtnRef = useRef<any>(false);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const isEditAccess = checkAcessRights(location.pathname, EDIT_ACCESS);
  const isDeleteAccess = checkAcessRights(location.pathname, DELETE_ACCESS);

  const ShippingMovementsList = useAppSelector(
    (state) => state.shippingMovementslist.ShippingMovementsList
  );
  const loading = useAppSelector(
    (state) => state.shippingMovementslist.loading
  );
  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);
  const cellfilter = useAppSelector(
    (state) => state.shippingMovementslist.filter
  );

  useEffect(() => {
    return () => {
      dispatch(setCurrentPage(0));
      if (!isEditBtnRef.current) {
        dispatch(clearFilter());
      }
    };
  }, []);

  useEffect(() => {
    const payload = {
      ...cellfilter,
      port_id: cellfilter.port_id ? cellfilter.port_id.join(",") : "",
      to_date_etd: cellfilter?.to_date_etd
        ? moment(cellfilter?.to_date_etd).format("YYYY-MM-DD")
        : "",
      from_date_etd: cellfilter?.from_date_etd
        ? moment(cellfilter?.from_date_etd).format("YYYY-MM-DD")
        : "",
      to_date_eta: cellfilter?.to_date_eta
        ? moment(cellfilter?.to_date_eta).format("YYYY-MM-DD")
        : "",
      from_date_eta: cellfilter?.from_date_eta
        ? moment(cellfilter?.from_date_eta).format("YYYY-MM-DD")
        : "",
      cut_off_datetime: cellfilter.cut_off_datetime
        ? moment(cellfilter.cut_off_datetime).format("YYYY-MM-DD")
        : "",
      line_id: cellfilter.line_id ? cellfilter.line_id.join(",") : "",
      agent_id: cellfilter.agent_id ? cellfilter.agent_id.join(",") : "",
      next_port_id: cellfilter.next_port_id
        ? cellfilter.next_port_id.join(",")
        : "",
      limit: +pageLimit,
      skip: +currentPage * +pageLimit,
    };
    dispatch(getAllShippingMovements(payload));
  }, [currentPage, pageLimit]);

  const [filter, setFilter] = React.useState<
    CompositeFilterDescriptor | undefined
  >(undefined);

  const pageChange = (event: GridPageChangeEvent) => {
    const newPage = event.page.skip / event.page.take;
    dispatch(setPageLimit(event.page.take));
    dispatch(setCurrentPage(newPage));
  };

  const MyEditCommandCell = (props: GridCellProps) => {
    // const handleEdit = (shipping_guid: number) => {
    //   navigate("/shippingmovements/edit", {
    //     state: { shipping_guid: shipping_guid },
    //   });
    // };
    const handleOpenDeleteDialog = (shipping_guid: string) => {
      dispatch(openDialog("deleteShippingMovements"));
      dispatch(setShippingMovementsGUID(shipping_guid));
    };

    const handleEditItemClick = (formType: string, shipping_guid: string) => {
      if (formType === "SHIPPING") {
        navigate("/shippingmovements/edit", {
          state: { shipping_guid: shipping_guid },
        });
      } else if (formType === "CONTAINER") {
        navigate("/containerimportdischarge/edit", {
          state: { shipping_guid: shipping_guid },
        });
      } else if (formType === "VESSELS") {
        navigate("/vesselsexportloading/edit", {
          state: { shipping_guid: shipping_guid },
        });
      }
    };
    return (
      <td
        style={{ ...props.style, textAlign: "center" }}
        className={`${props.className} action-td`}
      >
        {isEditAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Edit"
            ref={isEditBtnRef}
            onClick={() => {
              isEditBtnRef.current = true;
              handleEditItemClick(
                props.dataItem?.form_type,
                props.dataItem?.shipping_guid
              );
            }}
          >
            <FiEdit
              className="absolute-position"
              style={{ fontSize: "20px" }}
            />
          </IconButton>
        )}
        {isDeleteAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Delete"
            onClick={() =>
              handleOpenDeleteDialog(props.dataItem?.shipping_guid)
            }
          >
            <MdDelete
              className="absolute-position"
              style={{ fontSize: "24px" }}
            />
          </IconButton>
        )}
      </td>
    );
  };

  const handleFilterChange = (e: GridFilterChangeEvent) => {
    setFilter(e.filter);
  };
  const HeaderCustomCell = (props: GridCustomHeaderCellProps) => (
    <HeaderThElement
      columnId={props.thProps?.columnId || ""}
      {...props.thProps}
      className={`table-header ${props.index === 15 ? "locked-header" : ""}`}
    >
      {props.children}
    </HeaderThElement>
  );

  const CustomCell = (props: any) => {
    return (
      <td {...props.tdProps} colSpan={1} className={"table-cell"}>
        {props.children}
      </td>
    );
  };

  const MyDataCustomCell = (props: GridCustomCellProps) => (
    <CustomCell {...props} />
  );

  const handleEditItemClickCell = (formType: string, shipping_guid: string) => {
    if (formType === "SHIPPING") {
      navigate("/shippingmovements/edit", {
        state: { shipping_guid: shipping_guid },
      });
    } else if (formType === "CONTAINER") {
      navigate("/containerimportdischarge/edit", {
        state: { shipping_guid: shipping_guid },
      });
    } else if (formType === "VESSELS") {
      navigate("/vesselsexportloading/edit", {
        state: { shipping_guid: shipping_guid },
      });
    }
  };
  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      <KendoGrid
        className="sipping-moment-list-grid"
        style={{ maxHeight: "calc(100vh - 152px)" }}
        filterable={true}
        filter={filter}
        data={
          filter
            ? filterBy(ShippingMovementsList, filter)
            : ShippingMovementsList
        }
        onFilterChange={handleFilterChange}
        total={
          ShippingMovementsList[0]?.item_count || ShippingMovementsList.length
        }
        skip={currentPage * pageLimit}
        take={pageLimit}
        pageable={{
          buttonCount: 5,
          pageSizes: [5, 10, 50, 100, 300, 500],
          pageSizeValue: pageLimit,
          type: "input",
        }}
        onPageChange={pageChange}
        cells={{
          headerCell: HeaderCustomCell,
          data: MyDataCustomCell,
        }}
      >
        <Column
          field="eta"
          title="ETA"
          width={120}
          cell={(props: any) => (
            <>
              {isEditAccess ? (
                <td
                  className="hoverableName"
                  onClick={() => {
                    isEditBtnRef.current = true;
                    handleEditItemClickCell(
                      props.dataItem?.form_type,
                      props.dataItem?.shipping_guid
                    );
                  }}
                >
                  {props.dataItem?.eta}
                </td>
              ) : (
                <td className={`normalName`}>{props.dataItem?.eta}</td>
              )}
            </>
          )}
        />
        <Column field="form_type" title="Type" width={120} />
        <Column field="port_name" title="Port" width={350} />
        <Column field="cut_off_datetime" title="Cut Off Date" width={120} />
        <Column field="cut_off_time" title="Cut Off Time" width={120} />
        <Column field="etd" title="ETD" width={150} />
        <Column
          field="vessels_name"
          title="Vessel's Name"
          filterable
          width={150}
          // filterCell={CommonFilterCell}
        />
        <Column field="voj_no" title="VOY NO" width={150} />
        <Column field="vcn" title="VCN" width={150} />
        <Column field="line_name" title="Lines" width={150} />
        <Column field="agent_name" title="Agents" width={250} />
        <Column field="will_load_for" title="Will Load For" width={300} />
        <Column field="at_jetty" title="At Jetty" width={150} />
        <Column field="cargo" title="Cargo" width={150} />
        <Column field="next_port" title="Next Port" width={150} />
        {(isEditAccess || isDeleteAccess) && (
          <Column
            field="id"
            title="Actions"
            cell={MyEditCommandCell}
            width={"140px"}
            filterable={false}
            locked={true}
          />
        )}
      </KendoGrid>
    </>
  );
};

const DeleteShippingMovementsDialog: React.FC = () => {
  const dispatch = useAppDispatch();
  const ShippingMovementsGUID = useAppSelector(
    (state) => state.shippingMovementslist.ShippingMovementsGUID
  );
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);
  const handleDeleteAction = async (ID: string) => {
    if (ID) {
      const response = await dispatch(deleteShippingMovements(ID));
      const payload = {
        limit: +pageLimit,
        skip: +currentPage * +pageLimit,
      };
      if (response.payload.Data.Status === 200) {
        dispatch(getAllShippingMovements(payload));
        dispatch(closeDialog());
        dispatch(clearShippingMovementsGUID());
      } else {
        dispatch(getAllShippingMovements(payload));
        dispatch(closeDialog());
        dispatch(clearShippingMovementsGUID());
      }
    }
  };

  return (
    <>
      {dialogName === "deleteShippingMovements" && (
        <AppDialog>
          <>
            <Typography.h5>{"Delete Shipping Movement"}</Typography.h5>
            <GridLayout>
              <GridLayoutItem>
                <Typography.p>
                  Are you sure you want to delete this Shipping Movement?
                </Typography.p>
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <DialogCloseButton themeColor="error" />
                <Button
                  fillMode={"solid"}
                  themeColor={"error"}
                  onClick={() => handleDeleteAction(ShippingMovementsGUID)}
                  type="button"
                >
                  Delete
                </Button>
              </GridLayoutItem>
            </GridLayout>
          </>
        </AppDialog>
      )}
    </>
  );
};

// const CommonFilterCell = (props: any) => {
//   const dispatch = useAppDispatch();
//   const currentPage = useAppSelector((state) => state.pagination.currentPage);
//   const pageLimit = useAppSelector((state) => state.pagination.pageLimit);
//   const FilterCustomSM: any = useAppSelector(
//     (state) => state.shippingMovementslist.FilterCustomSM
//   );
//   const isFilterRef = useRef(true);
//   const [inputValue, setInputValue] = useState(props.value || "");
//   const [inputField, setInputField] = useState(props.field || "");

//   const onChange = (event: any) => {
//     setInputValue(event.target.value);
//     setInputField(event.target.name);
//   };

//   const delayedApiCall = React.useCallback(
//     _debounce((updatedFilters: any) => {
//       dispatch(setCurrentPage(0));
//       const payload = {
//         ...updatedFilters,
//         limit: +pageLimit,
//         skip: 0 * +pageLimit,
//       };

//       dispatch(getAllShippingMovements(payload));
//     }, 300),
//     [dispatch]
//   );

//   useEffect(() => {
//     if (!isFilterRef.current) {
//       const updatedFilters = { ...FilterCustomSM, [inputField]: inputValue };
//       dispatch(setFilterCustomSM(updatedFilters));
//       delayedApiCall(updatedFilters);
//     } else {
//       isFilterRef.current = false;
//     }
//     return () => {
//       delayedApiCall.cancel();
//     };
//   }, [inputValue, delayedApiCall]);

//   const onClearButtonClick = (event: any) => {
//     event.preventDefault();
//     props.onChange({
//       value: null,
//       operator: "",
//       syntheticEvent: event,
//     });

//     const updatedFilters = { ...FilterCustomSM, [props.field]: "" };
//     dispatch(setFilterCustomSM(updatedFilters));

//     const payload = {
//       ...updatedFilters,
//       limit: +pageLimit,
//       skip: +currentPage * +pageLimit,
//     };

//     dispatch(getAllShippingMovements(payload));
//   };
//   return (
//     <div className="d-flex">
//       <TextBox
//         value={FilterCustomSM[props.field] || ""}
//         name={props.field || ""}
//         onChange={onChange}
//       />
//       <Button
//         svgIcon={filterClearIcon}
//         title="Clear"
//         disabled={!FilterCustomSM[props.field]}
//         onClick={onClearButtonClick}
//         type="button"
//         style={{
//           marginLeft: "8px",
//         }}
//       ></Button>
//     </div>
//   );
// };

export default ShippingMovementsList;
